<template>
  <div>
    <div class="swiper-container child">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in msg" :key="item.id">
          <img :src="item.imgUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";

export default {
  name: "Carousel",
  props: {
    msg: {
      type: Array,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      new Swiper(".child", {
        loop: false,
        autoplay: false,
      });
    }, 500);
  },
  components: {},
};
</script>

<style scoped>
.child {
  height: 50vh;
}
.swiper-slide img{
  width: 100%;
  height: 100%;
}
</style>
